import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    opacity: 0;\n    position: absolute;\n    margin: 0;\n    height: 0;\n    width: 0;\n\n    &:not(:checked)\n        + ", ":hover:before,\n        &:not(:checked)\n        + ", ":active:before {\n        border-width: 1px;\n        border-style: solid;\n        ", "\n    }\n\n    &:checked\n        + ", ":hover:before,\n        &:not(:checked)\n        + ", ":active:before {\n        ", "\n    }\n\n    &:checked + ", ":after {\n        opacity: 1;\n        transform: scale(1);\n        ", "\n    }\n\n    &:checked + ", ":before {\n        opacity: 1;\n        box-sizing: border-box;\n        ", "\n    }\n\n    &:disabled + ", ":before {\n        box-shadow: none;\n        border-width: 1px;\n        border-style: solid;\n        box-sizing: border-box;\n        ", "\n    }\n\n    &:not(:checked) + ", ":after {\n        opacity: 0;\n    }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n                  margin-top: ", ";\n              "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n\n    ", "\n\n    &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: ", "px;\n        height: ", "px;\n        border-radius: 4px;\n        box-sizing: border-box;\n        ", "\n        transition: all ", "s ease;\n    }\n\n    &::after {\n        content: '';\n        position: absolute;\n        transition: all ", "s ease;\n\n        ", "\n    }\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    margin: 0;\n    font-weight: ", ";\n\n    ", "\n    ", ";\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["", "", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    transform: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
import { mouseCursor, pointerEvents } from '../../styling';
import { transitionDurationInSec } from '../../constants';
import { spacing } from '../../system/mixins';
import { fontWeightRegular } from '../../tokens';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = {
  reallyChecked: true,
  checkedIcon: true,
  hasLabel: true
};
var sizes = {
  checkbox: {
    side: 16
  }
};

var checkmarkRotation = function checkmarkRotation(_ref) {
  var checkedIcon = _ref.checkedIcon;
  return css(_templateObject(), checkedIcon === 'tick' ? ' rotate(45deg)' : '');
};

var checkedBefore = function checkedBefore(_ref2) {
  var Checkbox = _ref2.theme.componentOverrides.Checkbox;
  return Checkbox.Root.checked.base;
};

var checkedHover = function checkedHover(_ref3) {
  var Checkbox = _ref3.theme.componentOverrides.Checkbox;
  return Checkbox.Root.checked.hover;
};

var uncheckedHover = function uncheckedHover(_ref4) {
  var Checkbox = _ref4.theme.componentOverrides.Checkbox;
  return Checkbox.Root.unchecked.hover;
};

var disabledBefore = function disabledBefore(_ref5) {
  var Checkbox = _ref5.theme.componentOverrides.Checkbox;
  return Checkbox.Root.checked.disabled;
};

var checkmarkBox = function checkmarkBox(_ref6) {
  var Checkbox = _ref6.theme.componentOverrides.Checkbox;
  return Checkbox.Root.checkmark.box;
};

var checkmarkStyle = function checkmarkStyle(_ref7) {
  var Checkbox = _ref7.theme.componentOverrides.Checkbox,
      checkedIcon = _ref7.checkedIcon,
      disabled = _ref7.disabled;
  var checkmarkColor = disabled ? Checkbox.Root.checkmark.disabled : Checkbox.Root.checkmark.base;
  var tickStyle = checkedIcon === 'tick' ? "\n                  left: 5px;\n                  top: 3px;\n                  width: 4px;\n                  height: 7px;\n                  border-width: 0 1px 1px 0;\n                  border-style: solid;\n                  transform: rotate(45deg);\n              " : "\n                  left: 4px;\n                  top: 7px;\n                  width: 8px;\n                  height: 1px;\n                  border-style: solid;\n                  border-width: 0 0 1px 0;\n                  transform: rotate(0);\n              ";
  return css(_templateObject2(), checkmarkColor, tickStyle);
};

export var CheckboxRoot = styled.label.withConfig(getPropsBlocker(propertyList))(_templateObject3(), fontWeightRegular, mouseCursor, getComponentOverride('Checkbox'), marginAttributes);
export var CheckboxCheckmark = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), sizes.checkbox.side, sizes.checkbox.side, function (_ref8) {
  var hasLabel = _ref8.hasLabel;
  return hasLabel ? css(_templateObject5(), spacing(1)) : '';
}, sizes.checkbox.side, sizes.checkbox.side, checkmarkBox, transitionDurationInSec, transitionDurationInSec, checkmarkStyle, pointerEvents);
export var CheckboxInput = styled.input.withConfig(getPropsBlocker(propertyList))(_templateObject6(), CheckboxCheckmark, CheckboxCheckmark, uncheckedHover, CheckboxCheckmark, CheckboxCheckmark, checkedHover, CheckboxCheckmark, checkmarkRotation, CheckboxCheckmark, checkedBefore, CheckboxCheckmark, disabledBefore, CheckboxCheckmark);